import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { AdminLayout, AdminLayoutContentCard } from '../../../common/components';
import { useDevices } from '../../../common/hooks';
import { requiredFieldMessage } from '../../../common/utils/validation.utils';
import DeviceForm from './DeviceForm';
import modelOptions from '../../../common/data/models.json';
import { useEffect } from 'react';

const schema = yup
    .object({
        serial_number: yup.string().trim().required(requiredFieldMessage()),
        model: yup.object().shape({
            value: yup.string().trim().required(requiredFieldMessage()),
            batteries: yup.number().required(),
        }),
        battery_slot_quantity: yup.number().required(requiredFieldMessage()),
        org_id: yup.object().shape({
            value: yup.string().trim(),
        }),
    })
    .required(requiredFieldMessage());

const initialValue = {
    serial_number: '',
    model: modelOptions[0],
    battery_slot_quantity: modelOptions[0].batteries,
    org_id: { value: '' },
};

export const payloadFromSchema = (data: typeof initialValue) => {
    return {
        ...data,
        model: data.model.value,
        org_id: data.org_id.value || null,
    };
};

const CreateDevice = () => {
    const { createDevice, loading, error } = useDevices();
    const navigate = useNavigate();

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialValue,
    });

    const model = watch('model');

    useEffect(() => {
        if (model) {
            setValue('battery_slot_quantity', model.batteries);
        }
        // eslint-disable-next-line
    }, [model]);

    const onSubmit = async (data: any) => {
        const payload = payloadFromSchema(data);

        try {
            await createDevice(payload);
            navigate('/devices');
        } catch (err) {
            // try again...
        }
    };

    return (
        <AdminLayout title="Adicionar máquina">
            <AdminLayoutContentCard>
                <DeviceForm
                    control={control}
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    errors={errors} // client-side validation
                    error={error} // server-side error
                    loading={loading}
                />
            </AdminLayoutContentCard>
        </AdminLayout>
    );
};

export default CreateDevice;
